// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import type { MediaGallery } from '../../../types/keepeekType';
import ParalaxScroller from '../../../components/paralaxScroller/ParalaxScroller';
import MenuItem from '../../../components/paralaxScroller/MenuItem';
import MenuPage from '../../../components/paralaxScroller/MenuPage';
import KeepeekMediaPatchwork from '../../common/KeepeekMediaPatchwork';
import Loader from '../../common/Loader';
import { BROCHURE_PLAN, VIRTUAL_VISITS } from '../../../utils/keepeekUtils';
import NoElementFound from '../../../components/NoElementFound';
import KeepeekMediaVirtualVisit from '../../common/KeepeekMediaVirtualVisit';
import type { EmbeddedUrl } from '../../../types/embeddedUrlTypes';

type Props = {
  galleries: MediaGallery[],
  embeddedUrls?: EmbeddedUrl[],
  isLoading: boolean,
}

type State = {}

class MallMediaGallery extends React.Component<Props, State> {
  state = {};

  ref: ?HTMLDivElement;

  renderGalleryContent = gallery => (
    <MenuPage key={`Item${gallery.id}`} id={gallery.gallery}>
      <div className="mall-media-galleries-title">
        {gallery.gallery === BROCHURE_PLAN ?
          <Translate value="mallData.MEDIA.BROCHURE_PLAN" />
          : gallery.gallery
        }
        <hr />
      </div>
      {gallery.gallery === VIRTUAL_VISITS ?
        (
          <KeepeekMediaVirtualVisit
            medias={gallery.medias}
            embeddedUrls={this.props.embeddedUrls}
          />
        ) : (
          <KeepeekMediaPatchwork
            medias={gallery.medias}
            isAlreadyLoaded
          />
        )
      }
    </MenuPage>
  )

  renderVirtualVisitWithoutMedia = () => (
    <MenuPage id="VIRTUAL_VISITS">
      <div className="mall-media-galleries-title">
        <Translate value="mallData.MEDIA.VIRTUAL_VISITS" />
        <hr />
      </div>
      <KeepeekMediaVirtualVisit
        embeddedUrls={this.props.embeddedUrls}
      />
    </MenuPage>
  )

  renderContent = () => {
    if (this.props.isLoading) {
      return (
        <div className="loading-page">
          <Loader isLoading />
        </div>
      );
    }
    if (this.props.galleries.length > 0) {
      return this.props.galleries.map(this.renderGalleryContent);
    }

    if (!!this.props.embeddedUrls && this.props.embeddedUrls.length > 0) {
      return this.renderVirtualVisitWithoutMedia();
    }

    return (
      <div className="loading-page">
        <NoElementFound text={<Translate value="mallData.MEDIA.NO_MEDIA" />}>
          <div key="key3" className="text">
            <Translate value="mallData.MEDIA.EMPTY_GALLERY" />
          </div>
        </NoElementFound>
      </div>
    );
  }

  render() {
    return (
      <ParalaxScroller
        className="mall-media-galleries"
        scrollableElement={this.ref}
      >
        {
          this.props.galleries.length > 1 &&
          <div className="aside-nav">
            {
              this.props.galleries.map(gallery => (
                <MenuItem className="gallery-selector" key={`Item${gallery.id}`} id={gallery.gallery}>
                  {gallery.gallery === BROCHURE_PLAN ?
                    <Translate value="mallData.MEDIA.BROCHURE_PLAN" />
                  : gallery.gallery
                  }
                </MenuItem>
              ))
            }
          </div>
        }
        <div
          ref={(ref) => {
            this.ref = ref;
          }}
          className="scrollable-content"
        >
          {this.renderContent()}
        </div>
      </ParalaxScroller>
    );
  }
}

export default connect(state => ({
  isLoading: state.page.isMediaLoading,
}))(MallMediaGallery);
